// Sends one question to the Copilote and reads the streamed answer (server-sent events). fetch rather than axios: the answer
// arrives piece by piece. Same cookie session as every API call; one refresh-and-retry on 401, like lib/api.js.
import api, { API } from "./api";
import { parseSse } from "./copilot";

export class CopilotRequestError extends Error {
  constructor(status, code, message) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

const FALLBACK = "Le Copilote n'a pas pu répondre. Réessayez dans quelques instants.";

async function post(body, signal) {
  return fetch(`${API}/assistant/messages`, {
    method: "POST", credentials: "include", signal, headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
    body: JSON.stringify(body),
  });
}

async function refusal(response) {
  let detail = null;
  try {
    detail = (await response.json()).detail;
  } catch {
    // not JSON: keep the generic message
  }
  if (detail && typeof detail === "object" && !Array.isArray(detail)) return new CopilotRequestError(response.status, detail.code, detail.message || FALLBACK);
  return new CopilotRequestError(response.status, null, typeof detail === "string" ? detail : FALLBACK);
}

// `resumeAfter`: instead of a question, resume the conversation after the person decided on that proposal (the server writes
// what the assistant reads about the decision).
export async function streamQuestion({ text, resumeAfter, conversationId, page, signal, onEvent }) {
  const body = { ...(resumeAfter ? { resume_after: resumeAfter } : { text, ...(page ? { page } : {}) }), ...(conversationId ? { conversation_id: conversationId } : {}) };
  let response = await post(body, signal);
  if (response.status === 401) {
    try {
      await api.post("/auth/refresh");
    } catch {
      throw new CopilotRequestError(401, "session", "Votre session a expiré : reconnectez-vous.");
    }
    response = await post(body, signal);
  }
  if (!response.ok) throw await refusal(response);
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const { events, rest } = parseSse(buffer);
    buffer = rest;
    events.forEach(onEvent);
  }
  const { events } = parseSse(buffer + "\n\n");
  events.forEach(onEvent);
}
